(function () {
  const STORAGE_KEY = "shopifyWishlistHandles";

  function getWishlistHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }
  function setWishlistHandles(arr) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  }
  function isInWishlist(handle) {
    return getWishlistHandles().includes(handle);
  }
  function addToWishlist(handle) {
    const arr = getWishlistHandles();
    if (!arr.includes(handle)) {
      arr.push(handle);
      setWishlistHandles(arr);
    }
  }
  function removeFromWishlist(handle) {
    setWishlistHandles(getWishlistHandles().filter(h => h !== handle));
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".wishlist-btn").forEach(btn => {
      const handle = btn.getAttribute("data-product-handle");
      if (isInWishlist(handle)) btn.classList.add("is-saved");

      btn.addEventListener("click", evt => {
        evt.preventDefault();
        if (isInWishlist(handle)) {
          removeFromWishlist(handle);
          btn.classList.remove("is-saved");
        } else {
          addToWishlist(handle);
          btn.classList.add("is-saved");
        }
      });
    });
  });
})();
